const { createContext } = require("react");

const githubContext = createContext();

export default githubContext;